import * as Sentry from '@sentry/browser';

import { hasValidEnvironmentFor, dsn, environment } from './config';
import ignores from './ignores';

hasValidEnvironmentFor.warn() && console.warn(`No Sentry DSN provided for "${environment}" environment.`);

if(hasValidEnvironmentFor.reports()){
  let initOptions = {
    dsn,
    environment,
    tracesSampleRate: 0.01, // tracking 1% of the traces
    profilesSampleRate: 0.01, // tracking 1% of the profiles (0.01 * 0.01 = 0.0001)
    integrations: [ Sentry.browserTracingIntegration() ],
    ...ignores,
  };

  if (environment === 'production') {
    initOptions = { ...initOptions, allowUrls: [/therapistaid\.com/] };
  }

  typeof user !== 'undefined' && Sentry.setUser(user);

  Sentry.init(initOptions);

  window.Sentry = Sentry;
}

const addBreadcrumb = ({
  category = 'content.list',
  message = null,
  level = 'info',
  data = {}
} = {}) => {
	const breadcrumb = {
		category,
		message,
		level,
		type: 'default',
    data: { ...data, url: window.location.href },
	};

	if(hasValidEnvironmentFor.reports()){
		Sentry.addBreadcrumb(breadcrumb);

		return;
	}

	if(environment !== 'production'){
		console.log(breadcrumb);
	}
}

window.addBreadcrumb = addBreadcrumb;

export default Sentry;
